// Job-related type definitions for asynchronous operations

export type JobStatus = "PENDING" | "COMPLETE" | "FAILED";

// Job status constants for better type safety and reusability
// Usage: if (status === JOB_STATUS.COMPLETE) { ... }
export const JOB_STATUS = {
  PENDING: "PENDING" as const,
  COMPLETE: "COMPLETE" as const,
  FAILED: "FAILED" as const,
} as const;

// Type guard to check if a string is a valid JobStatus
export function isJobStatus(status: string): status is JobStatus {
  return Object.values(JOB_STATUS).includes(status as JobStatus);
}

// Helper function to get user-friendly status text
export function getJobStatusDisplayText(status: JobStatus): string {
  switch (status) {
    case JOB_STATUS.PENDING:
      return "Processing...";
    case JOB_STATUS.COMPLETE:
      return "Complete";
    case JOB_STATUS.FAILED:
      return "Failed";
    default:
      return "Unknown";
  }
}

// DTO for async import response (202 Accepted)
export interface AsyncImportResponseDTO {
  jobId: string;
}

export interface JobResult {
  id: string;
  scrapeMethod?: string | null;
  [key: string]: unknown;
}

// DTO for job status response
export interface JobStatusDTO {
  jobId: string;
  status: JobStatus;
  createdAt?: Date;
  completedAt?: Date;
  errorMessage?: string;
  result?: JobResult;
}

export interface ImportJobPollingState {
  isPolling: boolean;
  status: JobStatus | null;
  error: string | null;
  recipeId: string | null;
  scrapeMethod: string | null;
}
